import React from "react";
const TestimonialsSection = () => {
  return <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12">What Researchers Say</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <p className="italic text-gray-600 mb-4">"LabSwapp helped our lab find specialized antibodies that were no longer commercially available. It saved us months of work developing them ourselves."</p>
            <div className="flex items-center">
              <div className="ml-4">
                <p className="font-semibold">Dr. Emily Chen</p>
                <p className="text-sm text-gray-500">Immunology Research, UCLA</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <p className="italic text-gray-600 mb-4">"We had excess reagents after completing a grant project. Instead of letting them expire, we shared them with neighboring universities through LabSwapp."</p>
            <div className="flex items-center">
              <div className="ml-4">
                <p className="font-semibold">Prof. Michael Rodriguez</p>
                <p className="text-sm text-gray-500">Chemistry Department, ETH Zurich</p>
              </div>
            </div>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <p className="italic text-gray-600 mb-4">"As a small lab with limited funding, LabSwapp has been invaluable. We've saved thousands on reagents while making connections with researchers worldwide."</p>
            <div className="flex items-center">
              <div className="ml-4">
                <p className="font-semibold">Dr. Sophia Patel</p>
                <p className="text-sm text-gray-500">Molecular Biology, University of Valencia</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default TestimonialsSection;